import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PaginationComponent {
  @Input() collectionSize: number = 0;
  @Output() pageChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() maxSize: number = 0;
  @Input() pageSize: number = 10;

  page = 1;

  onPageChange(page: any): void {
    
    this.pageChanged.emit({
      currentPage: page,
    });
  }
}
